
















































































import Vue from "vue";
import { ChangeReqStatus } from "../../types/dossier/ChangeReqStatus";
import EhrButton from "./../interface/EhrButton.vue";
export default Vue.extend({
  name: "dossier-collapse",
  props: {
    status: {
      required: true,
    },
    date: {},
    canSubmit: {},
    canCancel: {},
    isOpen: {
      required: false,
      default: false,
    },
  },
  components: { EhrButton },
  data() {
    return {
      bestanden: [],
      extraInfo: "Extra bewijsstukken over uw verblijfplaats gevraagd.",
      opened: this.isOpen,
    };
  },
  methods: {
    toggleCollapse(): void {
      this.opened = !this.opened;
    },
    onFilesChanged(value): void {
      this.bestanden = value;
    },
    onCollapseSubmit(): void {
      if (this.needsMoreInfo) {
        this.$emit("collapse-submit");
      }
    },
    onCollapseCancel(): void {
      if (this.isInProgress) {
        this.$emit("collapse-cancel");
      }
      this.toggleCollapse();
    },
  },
  computed: {
    needsMoreInfo(): boolean {
      return this.status == ChangeReqStatus.NeedsInfo;
    },
    isInProgress(): boolean {
      return this.status == ChangeReqStatus.InProgress;
    },
  },
});
